import { truckApi } from "./truck.api";

export const {
  useGetIsTruckQuery,
  useLazyGetIsTruckQuery,
  useSaveNewTruckMutation,
  useGetTruckQuery,
  useLazyGetTruckQuery,
  useSaveDeleteTruckMutation,
  useSaveEditTruckMutation,
  useSaveRebindTruckMutation,
  useSaveUnbindTruckMutation
} = truckApi;
